<template>
  <g id="score" transform="translate(0 -150)">
    <g id="rainbow">
      <path
        class="cls-37"
        d="M910.9 42.9A177.1 177.1 0 00822 18v57.6h-.1v121.5l72.4-125.5z"
        transform="translate(17)"
      />
      <path
        class="cls-38"
        d="M821.9 197.2L761 91.7h.1l-29.2-50.6a179.6 179.6 0 00-66.6 65.5l21.7 12.5z"
        transform="translate(17)"
      />
      <path
        class="cls-39"
        d="M998.8 197.1a178.7 178.7 0 00-23.4-88.7l-48.2 27.8L822 197.1h176.8z"
        transform="translate(17)"
      />
      <path
        class="cls-40"
        d="M821.9 41.1h.1V18h-2.1a178.2 178.2 0 00-88 23.1l22.5 39 67.5 117h.1z"
        transform="translate(17)"
      />
      <path
        class="cls-41"
        d="M975.4 108.4a178.5 178.5 0 00-64.5-65.5l-28.2 48.8L822 197l124-71.7z"
        transform="translate(17)"
      />
      <path
        class="cls-42"
        d="M821.9 197.1l-105.4-60.9-51.2-29.6a179.1 179.1 0 00-24.5 90.5h181.1z"
        transform="translate(17)"
      />
    </g>
    <g id="bad">
      <path
        class="cls-20"
        d="M667.6 157.9h4.8c4.1 0 8.3 2.3 8.3 9.7s-4.2 9.8-8.3 9.8v12.9h-4.8zm4.8 14.6c3 0 3.5-1.1 3.5-4.7s-.5-5-3.5-5zM689.6 190.7c-6.4 0-6.4-7-6.4-7v-19.1s0-7 6.4-7 6.3 7 6.3 7v19.1s0 7-6.3 7zm0-28.5c-1.7 0-1.6 2.4-1.6 2.4v19.1s-.1 2.3 1.6 2.3 1.5-2.3 1.5-2.3v-19.1s.1-2.4-1.5-2.4zM705.1 190.7c-6.3 0-6.3-7-6.3-7v-19.1s0-7 6.3-7 6.4 7 6.4 7v19.1s0 7-6.4 7zm0-28.5c-1.6 0-1.5 2.4-1.5 2.4v19.1s-.1 2.3 1.5 2.3 1.6-2.3 1.6-2.3v-19.1s.1-2.4-1.6-2.4zM723.2 190.3l-2.5-13.7h-1.2v13.7h-4.8v-32.4h4.8c5.6 0 8.1 3.3 8.1 9.4 0 3.2-.9 6.1-2.7 7.3l3.1 15.7zm-3.7-27.7v9.6c1.3 0 3.5-.1 3.5-4.8s-2.2-4.8-3.5-4.8z"
        transform="translate(17)"
      />
    </g>
    <g id="good">
      <path
        class="cls-20"
        d="M919.2 169.4v-5.2s.1-2.5-1.7-2.5-1.6 2.5-1.6 2.5v20.2s-.1 2.5 1.6 2.5 1.7-2.5 1.7-2.5v-6.1h-2v-4.1h6.9v16.7h-2.9l-.6-1.6a4.8 4.8 0 01-3.8 2c-6.3 0-5.9-7.3-5.9-7.3v-19.8s0-7.3 6.6-7.3 6.6 7.3 6.6 7.3v5.2zM934 191.3c-6.6 0-6.6-7.3-6.6-7.3v-19.8s0-7.3 6.6-7.3 6.6 7.3 6.6 7.3V184s0 7.3-6.6 7.3zm0-29.6c-1.7 0-1.6 2.5-1.6 2.5V184s-.1 2.5 1.6 2.5 1.7-2.5 1.7-2.5v-19.8s0-2.5-1.7-2.5zM950.2 191.3c-6.6 0-6.6-7.3-6.6-7.3v-19.8s0-7.3 6.6-7.3 6.6 7.3 6.6 7.3V184s0 7.3-6.6 7.3zm0-29.6c-1.7 0-1.6 2.5-1.6 2.5V184s-.1 2.5 1.6 2.5 1.7-2.5 1.7-2.5v-19.8s0-2.5-1.7-2.5zM964 190.9h-3.9v-33.6h3.9c9.2 0 9.9 3.7 9.9 16.8s-.7 16.8-9.9 16.8zm1.1-4.9c3.5 0 3.7-.9 3.6-11.9s-.1-11.9-3.6-11.9z"
        transform="translate(17)"
      />
    </g>
    <g id="needle">
      <path
        id="point"
        class="cls-43"
        d="M839 188.6L824.4 70.8a1.9 1.9 0 00-3.8 0l-15.1 117.4.4-.2c9.9-6.4 23.9-5.9 33.1.6z"
        transform="translate(17)"
      />
      <circle
        class="cls-44"
        cx="821.9"
        cy="196.1"
        r="22"
        transform="translate(-3.7 133.1) rotate(-9.1)"
      />
    </g>
  </g>
</template>

<script>
import gsap from "gsap";

export default {
  computed: {
    score() {
      return this.$store.state.score;
    },
  },
  watch: {
    score(newValue, oldValue) {
      gsap.to("#needle", {
        duration: 0.3,
        rotation: newValue,
        transformOrigin: "50% 87%",
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
